<template>
  <div class="page-content">
    <div class="page-title">Conditions of cooperation</div>
    <div class="text">
      World Federation of UNESCO Clubs, Centres and Associations (WFUCA) is a
      non-governmental organization in official partnership (associate status)
      with UNESCO having its office at Bonvin Building in Paris.
    </div>

    <div class="sub-title">Instructions</div>
    <div class="text">
      World Federation of UNESCO Clubs, Centres and Associations (WFUCA) is a
      non-governmental organization in official partnership (associate status)
      with UNESCO having its office at Bonvin Building in Paris.
    </div>

    <div class="sub-title">Criterion</div>
    <div class="text">
      World Federation of UNESCO Clubs, Centres and Associations (WFUCA) is a
      non-governmental organization in official partnership (associate status)
      with UNESCO having its office at Bonvin Building in Paris.
    </div>

    <div class="sub-title">Consult</div>
    <div class="text">
      <div class="line">
        <span>Address: </span>
        <span>1, rue Miollis – Office B5.2275732 Paris Cedex – France</span>
      </div>
      <div class="line">
        <span>Telephone: </span>
        <span>+33 (0) 1 45 68 48 19</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content .line {
    flex-wrap: wrap;
    span {
      display: block;
      width: 100% !important;
      margin-bottom: 10px !important;
    }
  }
}
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
    .line {
      padding-bottom: fh(20vh, pc);
      span {
        &:nth-child(1) {
          display: inline-block;
          font-size: fh(18vh, pc);
          color: #bbbbbb;
          line-height: fh(22vh, pc);
          width: fw(200vw, pc);
        }
        &:nth-child(2) {
          font-size: fh(18vh, pc);
          color: #2a2a2a;
          font-weight: bold;
          line-height: fh(22vh, pc);
        }
      }
    }
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
